import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/subpage/why-content3.png';
import _imports_1 from '@/assets/image/subpage/why-content4.png';
import _imports_2 from '@/assets/image/subpage/why-content5.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-9bb281d0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "wrap"
};
var _hoisted_2 = {
  class: "inner"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("创新平台模式");

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "tip text-center"
  }, " 通过人机互动过程，对每个用户的情况进行采集分析 ", -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", {
    class: "col-title"
  }, "剧情化动画内容", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "col-hint"
  }, "抽象问题场景化，知识点切片化", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1
  }, null, -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", {
    class: "col-title"
  }, "闯关式编程任务", -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "col-hint"
  }, "精心设计的关卡挑战，重思考，收获成就感", -1);
});

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", {
    class: "col-title"
  }, "AI个性化体验", -1);
});

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "col-hint"
  }, "智能系统个性化设置闯关难度", -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ModuleTitle = _resolveComponent("ModuleTitle");

  var _component_a_col = _resolveComponent("a-col");

  var _component_a_row = _resolveComponent("a-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ModuleTitle, {
    class: "module-title"
  }, {
    default: _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }), _hoisted_4, _createVNode(_component_a_row, {
    class: "row-wrap",
    gutter: 50
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 12,
        class: "col-text col-text-1"
      }, {
        default: _withCtx(function () {
          return [_hoisted_5, _hoisted_6];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 12,
        class: "col-img"
      }, {
        default: _withCtx(function () {
          return [_hoisted_7];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 12,
        class: "col-img"
      }, {
        default: _withCtx(function () {
          return [_hoisted_8];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 12,
        class: "col-text col-text-2"
      }, {
        default: _withCtx(function () {
          return [_hoisted_9, _hoisted_10];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 12,
        class: "col-text col-text-3"
      }, {
        default: _withCtx(function () {
          return [_hoisted_11, _hoisted_12];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 12,
        class: "col-img"
      }, {
        default: _withCtx(function () {
          return [_hoisted_13];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]);
}